module.exports = __webpack_public_path__ + "img/744.a78b6f96.jpg";